import { Navigate } from "react-router-dom";
import { getEncryptedLocal } from "pages/Utility/cookieUtils";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const permissions = getEncryptedLocal("permissions");

  const hasPermission = permissions?.some(
    (item) => item?.permission_name === requiredPermission
  );

  if (!hasPermission) {
    return <Navigate to="/pages-403" replace />;
  }

  return children;
};

export default ProtectedRoute;
